export default __webpack_public_path__ + "static/media/noSignalNew.b19ab78a.svg";